
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"41.5","height":"29","rx":"3.5","fill":"#fff","stroke":"#B2BCCA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.438 19.823h-2.575l-1.93-7.583c-.092-.348-.287-.657-.573-.802A8.214 8.214 0 006 10.635v-.291h4.148c.572 0 1.001.438 1.073.947l1.002 5.47 2.573-6.417H17.3l-3.861 9.479zm5.292 0H16.3l2.002-9.48h2.432l-2.003 9.48zm5.148-6.853c.072-.51.501-.803 1.002-.803a4.419 4.419 0 012.36.437l.43-2.04a6.001 6.001 0 00-2.217-.439c-2.36 0-4.078 1.313-4.078 3.135 0 1.387 1.217 2.114 2.075 2.553.93.437 1.287.73 1.216 1.166 0 .656-.716.948-1.43.948-.859 0-1.718-.218-2.503-.584l-.43 2.043c.859.364 1.788.51 2.646.51 2.647.072 4.291-1.24 4.291-3.209 0-2.479-3.362-2.624-3.362-3.717zm11.872 6.853l-1.93-9.48h-2.075c-.429 0-.858.293-1.001.73l-3.575 8.75h2.503l.5-1.385h3.075l.286 1.385h2.217zm-3.647-6.927l.715 3.573h-2.003l1.288-3.573z","fill":"#28356A"}})])
          )
        }
      }
    